import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aba18b30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-parent-rel" }
const _hoisted_2 = { class: "profile-family-card" }
const _hoisted_3 = { class: "father" }
const _hoisted_4 = { class: "mother" }
const _hoisted_5 = {
  key: 0,
  class: "action-row"
}
const _hoisted_6 = { class: "owners-row" }
const _hoisted_7 = { class: "count" }

import { computed, ref } from 'vue'
import { FamilyAndChildren } from '@/rd/ViewFamilyStore'
import { AssertionType, FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useViewFamilyStore } from '@/rd/ViewFamilyStore'
import { useAssertionStore } from '@/rd/AssertionStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { CompositeId } from '@/rd/CompositeId'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import ParentConnector from '@/manage/ParentConnector.vue'
import ProfileRelationshipCard from './ProfileRelationshipCard.vue'
import ProfileChildren from './ProfileChildren.vue'
import ProfileRelationshipOwnersModal from './ProfileRelationshipOwnersModal.vue'
import ProfileParentRelationshipModal from './ProfileParentRelationshipModal.vue'
import ProfileSpouseRelationshipModal from './ProfileSpouseRelationshipModal.vue'
import Modal from '@/util/Modal.vue'
import ProfileParentRemoveModal from './ProfileParentRemoveModal.vue'
import { setProfileSpouseAsync } from './ProfileManager'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileParentRelationship',
  props: {
    childId: {},
    parentFamily: {},
    ownerOnly: { type: Boolean }
  },
  emits: [
  'addSibling',
  'remove',
],
  setup(__props: any, { emit }) {

const props = __props;





const parentRelModalRef = ref<InstanceType<typeof ProfileParentRelationshipModal>>()
const spouseRelModalRef = ref<InstanceType<typeof ProfileSpouseRelationshipModal>>()
const ownersModalRef = ref<InstanceType<typeof ProfileRelationshipOwnersModal>>()
const removeParentModalRef = ref<InstanceType<typeof ProfileParentRemoveModal>>()

const viewPersonStore = useViewPersonStore()
const viewFamilyStore = useViewFamilyStore()
const assertionStore = useAssertionStore()
const dataGroupStore = useDataGroupStore()

const childGroupId = computed(() => CompositeId.getGroupId(props.childId))
const viewFamilyRef = computed(() => viewFamilyStore.getAsyncFamily(props.parentFamily.family.id)?.data)
const familyIdRef = computed(() => viewFamilyRef.value?.matchIds.find(id => CompositeId.hasGroupId(id, childGroupId.value!)))
const fatherIdRef = computed(() => viewFamilyRef.value?.fatherId)
const motherIdRef = computed(() => viewFamilyRef.value?.motherId)

const childViewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.childId))
const relOwnerProfileIdsRef = computed(() => {
  // child relationship owners are the child matches that have a child assertion whose related family is
  // one of the family matches for this relationship
  return childViewPersonRef.value?.matchIds.flatMap(id => assertionStore.getLoadedForPerson(id))
    .filter(a => a.assertionType == AssertionType.Child && props.parentFamily.family.matchIds.includes(a.relatedItemId!))
    .map(a => a.subjectId!) ?? []
})
const isRelOwnerRef = computed(() => relOwnerProfileIdsRef.value.includes(props.childId))
const hasOtherOwnersRef = computed(() => relOwnerProfileIdsRef.value.some(id => id !== props.childId))
const childPermissionsRef = computed(() => dataGroupStore.getLoadedPermissions(CompositeId.getGroupId(props.childId)))
const canEditChildRef = computed(() => (childPermissionsRef.value & ItemPermissions.Modify) > 0)
const canEditRef = computed(() => canEditChildRef.value && relOwnerProfileIdsRef.value.includes(props.childId))

function showOwnersModal() {
  ownersModalRef.value?.open()
}

function onChange() {
  parentRelModalRef.value?.open(props.childId, props.parentFamily.family)
}

function onChangeParent(role: FamilyRelationshipRole) {
  const childGroupId = CompositeId.getGroupId(props.childId)!
  spouseRelModalRef.value?.open(childGroupId, props.parentFamily.family, role)
}

function onConfirmRemoveParent(role: FamilyRelationshipRole) {
  removeParentModalRef.value?.open(role, props.parentFamily.family.getSpouseId(role)!)
}

async function onRemoveParent(role: FamilyRelationshipRole) {
  if (familyIdRef.value) {
    await setProfileSpouseAsync(familyIdRef.value, undefined, role)
  }
}

function onRemove() {
  emit('remove', props.parentFamily.family)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ParentConnector, { layout: "small" }),
        _createVNode(ProfileRelationshipCard, {
          "rel-person-id": fatherIdRef.value,
          "context-person-id": _ctx.childId,
          "is-rel-owner": isRelOwnerRef.value,
          "owner-only": props.ownerOnly
        }, null, 8, ["rel-person-id", "context-person-id", "is-rel-owner", "owner-only"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ParentConnector, {
          layout: "small",
          mother: ""
        }),
        _createVNode(ProfileRelationshipCard, {
          "rel-person-id": motherIdRef.value,
          "context-person-id": _ctx.childId,
          "is-rel-owner": isRelOwnerRef.value,
          "owner-only": props.ownerOnly
        }, null, 8, ["rel-person-id", "context-person-id", "is-rel-owner", "owner-only"])
      ])
    ]),
    (canEditRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: onChange
          }, " Change "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: onRemove
          }, " Remove ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!props.ownerOnly && hasOtherOwnersRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-inline btn-link link-secondary",
            onClick: showOwnersModal
          }, [
            _createTextVNode(" Relationship defined in "),
            _createElementVNode("span", _hoisted_7, " (" + _toDisplayString(relOwnerProfileIdsRef.value.length) + ")", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ProfileChildren, {
      personId: _ctx.childId,
      family: _ctx.parentFamily,
      onAddChild: _cache[0] || (_cache[0] = ($event: any) => (emit('addSibling')))
    }, null, 8, ["personId", "family"]),
    _createVNode(ProfileParentRelationshipModal, {
      ref_key: "parentRelModalRef",
      ref: parentRelModalRef,
      onChange: onChangeParent,
      onRemove: onConfirmRemoveParent
    }, null, 512),
    _createVNode(ProfileSpouseRelationshipModal, {
      ref_key: "spouseRelModalRef",
      ref: spouseRelModalRef,
      "as-child": ""
    }, null, 512),
    _createVNode(ProfileRelationshipOwnersModal, {
      ref_key: "ownersModalRef",
      ref: ownersModalRef,
      "person-id": _ctx.childId,
      "owner-profile-ids": relOwnerProfileIdsRef.value
    }, null, 8, ["person-id", "owner-profile-ids"]),
    _createVNode(ProfileParentRemoveModal, {
      ref_key: "removeParentModalRef",
      ref: removeParentModalRef,
      onOk: onRemoveParent
    }, null, 512)
  ]))
}
}

})